import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";

export const useIsCategoryPageFiltered = (): boolean => {
  const {
    data: { activeFilterCount },
  } = useFilterStore(["activeFilterCount"]);
  return activeFilterCount > 0;
};
